import { render, staticRenderFns } from "./IncomeByTransfer.vue?vue&type=template&id=89a2c6e8&lang=pug&"
import script from "./IncomeByTransfer.vue?vue&type=script&lang=ts&"
export * from "./IncomeByTransfer.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeByTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports